var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('vue-editor',{attrs:{"id":"editor","useCustomImageHandler":""},on:{"imageAdded":_vm.handleImageAdded},model:{value:(_vm.htmlForEditor),callback:function ($$v) {_vm.htmlForEditor=$$v},expression:"htmlForEditor"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }